import * as Form from '../../Form';
import { PreviewUploadsField as SharedPreviewUploadsField } from '../../dapp-form/PreviewUploadsField';

interface PreviewUploadsFieldProps {
  dappPreviews: (File | null)[];
  previewDimensions?: { width: number; height: number } | null;
  onPreviewFileChange: (index: number, file: File | null) => void;
  onAddPreviewSlot: () => void;
  onRemovePreviewSlot: (index: number) => void;
}

export function PreviewUploadsField({
  dappPreviews,
  previewDimensions,
  onPreviewFileChange,
  onAddPreviewSlot,
  onRemovePreviewSlot,
}: PreviewUploadsFieldProps) {
  return (
    <SharedPreviewUploadsField
      dappPreviews={dappPreviews}
      previewDimensions={previewDimensions}
      onAddPreviewSlot={onAddPreviewSlot}
      onRemovePreviewSlot={onRemovePreviewSlot}
      renderUploadSlot={(index) => (
        <Form.MediaUploadInput
          name={`dappPreview-${index}`}
          value={dappPreviews[index]}
          onChange={(file: File | null) => onPreviewFileChange(index, file)}
          placeholderClassName="absolute inset-0"
          buttonType="add"
        />
      )}
    />
  );
}
